interface NearbyPlace {
  name: string;
  rating?: number;
  address: string;
  lat: number;
  lng: number;
  placeId: string;
  photo?: string;
}
export interface CountryInfo {
  emergency: string;
  police: string;
  ambulance: string;
  fire: string;
  countryName: string;
}

// ─── Constants ───────────────────────────────────────────────────────────────
const GOLD   = "#C8941F";
const CREAM  = "#FAF8F4";
const WHITE  = "#FFFFFF";
const DARK   = "#1C1410";
const MUTED  = "#9A8F85";
const BORDER = "#EDE8E0";
const RED    = "#DC2626";

// ─── Emergency numbers by country code ───────────────────────────────────────
// Source: Wikipedia/official government sources
export const EMERGENCY_DB: Record<string, Omit<CountryInfo, "countryName">> = {
  "EE": { emergency: "112", police: "110", ambulance: "112", fire: "112" },  // Estonia
  "US": { emergency: "911", police: "911", ambulance: "911", fire: "911" },
  "GB": { emergency: "999", police: "999", ambulance: "999", fire: "999" },
  "AU": { emergency: "000", police: "000", ambulance: "000", fire: "000" },
  "CA": { emergency: "911", police: "911", ambulance: "911", fire: "911" },
  "DE": { emergency: "112", police: "110", ambulance: "112", fire: "112" },
  "FR": { emergency: "112", police: "17",  ambulance: "15",  fire: "18"  },
  "ES": { emergency: "112", police: "091", ambulance: "061", fire: "080" },
  "IT": { emergency: "112", police: "113", ambulance: "118", fire: "115" },
  "PT": { emergency: "112", police: "112", ambulance: "112", fire: "112" },
  "NL": { emergency: "112", police: "112", ambulance: "112", fire: "112" },
  "BE": { emergency: "112", police: "101", ambulance: "100", fire: "100" },
  "AT": { emergency: "112", police: "133", ambulance: "144", fire: "122" },
  "CH": { emergency: "112", police: "117", ambulance: "144", fire: "118" },
  "SE": { emergency: "112", police: "112", ambulance: "112", fire: "112" },
  "NO": { emergency: "112", police: "112", ambulance: "113", fire: "110" },
  "DK": { emergency: "112", police: "112", ambulance: "112", fire: "112" },
  "FI": { emergency: "112", police: "112", ambulance: "112", fire: "112" },
  "PL": { emergency: "112", police: "997", ambulance: "999", fire: "998" },
  "CZ": { emergency: "112", police: "158", ambulance: "155", fire: "150" },
  "GR": { emergency: "112", police: "100", ambulance: "166", fire: "199" },
  "HR": { emergency: "112", police: "192", ambulance: "194", fire: "193" },
  "TR": { emergency: "112", police: "155", ambulance: "112", fire: "110" },
  "AE": { emergency: "999", police: "999", ambulance: "998", fire: "997" },
  "IN": { emergency: "112", police: "100", ambulance: "108", fire: "101" },
  "JP": { emergency: "110", police: "110", ambulance: "119", fire: "119" },
  "CN": { emergency: "110", police: "110", ambulance: "120", fire: "119" },
  "KR": { emergency: "112", police: "112", ambulance: "119", fire: "119" },
  "BR": { emergency: "190", police: "190", ambulance: "192", fire: "193" },
  "MX": { emergency: "911", police: "911", ambulance: "911", fire: "911" },
  "ZA": { emergency: "10111", police: "10111", ambulance: "10177", fire: "10177" },
  "NG": { emergency: "199", police: "199", ambulance: "199", fire: "199" },
  "KE": { emergency: "999", police: "999", ambulance: "999", fire: "999" },
  "TH": { emergency: "191", police: "191", ambulance: "1669", fire: "199" },
  "ID": { emergency: "112", police: "110", ambulance: "118", fire: "113" },
  "MY": { emergency: "999", police: "999", ambulance: "999", fire: "994" },
  "SG": { emergency: "999", police: "999", ambulance: "995", fire: "995" },
  "NZ": { emergency: "111", police: "111", ambulance: "111", fire: "111" },
  "AR": { emergency: "911", police: "101", ambulance: "107", fire: "100" },
  "CL": { emergency: "133", police: "133", ambulance: "131", fire: "132" },
  "RU": { emergency: "112", police: "102", ambulance: "103", fire: "101" },
  "UA": { emergency: "112", police: "102", ambulance: "103", fire: "101" },
  "IL": { emergency: "100", police: "100", ambulance: "101", fire: "102" },
  "SA": { emergency: "999", police: "999", ambulance: "997", fire: "998" },
  "EG": { emergency: "123", police: "122", ambulance: "123", fire: "180" },
  "MA": { emergency: "15",  police: "19",  ambulance: "15",  fire: "15"  },
  "TZ": { emergency: "112", police: "112", ambulance: "112", fire: "112" },
  "GH": { emergency: "191", police: "191", ambulance: "193", fire: "192" },
  "LV": { emergency: "112", police: "110", ambulance: "113", fire: "112" },
  "LT": { emergency: "112", police: "112", ambulance: "112", fire: "112" },
  "SK": { emergency: "112", police: "158", ambulance: "155", fire: "150" },
  "HU": { emergency: "112", police: "107", ambulance: "104", fire: "105" },
  "RO": { emergency: "112", police: "112", ambulance: "112", fire: "112" },
  "BG": { emergency: "112", police: "166", ambulance: "150", fire: "160" },
  "RS": { emergency: "112", police: "192", ambulance: "194", fire: "193" },
  "IE": { emergency: "999", police: "999", ambulance: "999", fire: "999" },
  "PH": { emergency: "911", police: "911", ambulance: "911", fire: "911" },
  "VN": { emergency: "113", police: "113", ambulance: "115", fire: "114" },
  "PK": { emergency: "115", police: "15",  ambulance: "115", fire: "16"  },
  "BD": { emergency: "999", police: "999", ambulance: "999", fire: "999" },
  "LK": { emergency: "119", police: "119", ambulance: "110", fire: "111" },
  "NP": { emergency: "100", police: "100", ambulance: "102", fire: "101" },
  "DEFAULT": { emergency: "112", police: "112", ambulance: "112", fire: "112" },
};


export const COUNTRY_META: Record<string, CountryMeta> = {
  EE: { name: "Estonia", currency: "Euro", currencyCode: "EUR", language: "Estonian", dialCode: "+372", drivingSide: "Right", plugType: "Type C / F", tipping: "Not expected — 5–10% for great service" },
  US: { name: "United States", currency: "US Dollar", currencyCode: "USD", language: "English", dialCode: "+1", drivingSide: "Right", plugType: "Type A / B", tipping: "15–20% at restaurants is standard" },
  GB: { name: "United Kingdom", currency: "Pound Sterling", currencyCode: "GBP", language: "English", dialCode: "+44", drivingSide: "Left", plugType: "Type G", tipping: "10–12.5% if not already included" },
  DE: { name: "Germany", currency: "Euro", currencyCode: "EUR", language: "German", dialCode: "+49", drivingSide: "Right", plugType: "Type C / F", tipping: "Round up or 5–10%" },
  FR: { name: "France", currency: "Euro", currencyCode: "EUR", language: "French", dialCode: "+33", drivingSide: "Right", plugType: "Type C / E", tipping: "Service usually included — round up if you like" },
  ES: { name: "Spain", currency: "Euro", currencyCode: "EUR", language: "Spanish", dialCode: "+34", drivingSide: "Right", plugType: "Type C / F", tipping: "Small change or 5–10%" },
  IT: { name: "Italy", currency: "Euro", currencyCode: "EUR", language: "Italian", dialCode: "+39", drivingSide: "Right", plugType: "Type C / F / L", tipping: "Not required — round up is fine" },
  PT: { name: "Portugal", currency: "Euro", currencyCode: "EUR", language: "Portuguese", dialCode: "+351", drivingSide: "Right", plugType: "Type C / F", tipping: "5–10% is appreciated" },
  NL: { name: "Netherlands", currency: "Euro", currencyCode: "EUR", language: "Dutch", dialCode: "+31", drivingSide: "Right", plugType: "Type C / F", tipping: "Round up or 5–10%" },
  LV: { name: "Latvia", currency: "Euro", currencyCode: "EUR", language: "Latvian", dialCode: "+371", drivingSide: "Right", plugType: "Type C / F", tipping: "5–10% is appreciated" },
  LT: { name: "Lithuania", currency: "Euro", currencyCode: "EUR", language: "Lithuanian", dialCode: "+370", drivingSide: "Right", plugType: "Type C / F", tipping: "5–10% is appreciated" },
  FI: { name: "Finland", currency: "Euro", currencyCode: "EUR", language: "Finnish", dialCode: "+358", drivingSide: "Right", plugType: "Type C / F", tipping: "Not expected" },
  SE: { name: "Sweden", currency: "Swedish Krona", currencyCode: "SEK", language: "Swedish", dialCode: "+46", drivingSide: "Right", plugType: "Type C / F", tipping: "Round up or 10%" },
  NO: { name: "Norway", currency: "Norwegian Krone", currencyCode: "NOK", language: "Norwegian", dialCode: "+47", drivingSide: "Right", plugType: "Type C / F", tipping: "Not expected" },
  DK: { name: "Denmark", currency: "Danish Krone", currencyCode: "DKK", language: "Danish", dialCode: "+45", drivingSide: "Right", plugType: "Type C / K", tipping: "Not expected — service included" },
  AE: { name: "United Arab Emirates", currency: "UAE Dirham", currencyCode: "AED", language: "Arabic", dialCode: "+971", drivingSide: "Right", plugType: "Type C / G", tipping: "10–15% is appreciated" },
  IN: { name: "India", currency: "Indian Rupee", currencyCode: "INR", language: "Hindi / English", dialCode: "+91", drivingSide: "Left", plugType: "Type C / D / M", tipping: "5–10% in cities" },
  JP: { name: "Japan", currency: "Japanese Yen", currencyCode: "JPY", language: "Japanese", dialCode: "+81", drivingSide: "Left", plugType: "Type A / B", tipping: "Not customary — can be seen as rude" },
  AU: { name: "Australia", currency: "Australian Dollar", currencyCode: "AUD", language: "English", dialCode: "+61", drivingSide: "Left", plugType: "Type I", tipping: "Not expected — round up for great service" },
  CA: { name: "Canada", currency: "Canadian Dollar", currencyCode: "CAD", language: "English / French", dialCode: "+1", drivingSide: "Right", plugType: "Type A / B", tipping: "15–20% at restaurants" },
  TH: { name: "Thailand", currency: "Thai Baht", currencyCode: "THB", language: "Thai", dialCode: "+66", drivingSide: "Left", plugType: "Type A / C / O", tipping: "Not required — small tips welcomed" },
  TR: { name: "Turkey", currency: "Turkish Lira", currencyCode: "TRY", language: "Turkish", dialCode: "+90", drivingSide: "Right", plugType: "Type C / F", tipping: "5–10% at restaurants" },
  SG: { name: "Singapore", currency: "Singapore Dollar", currencyCode: "SGD", language: "English / Malay / Mandarin / Tamil", dialCode: "+65", drivingSide: "Left", plugType: "Type G", tipping: "Not expected — service usually included" },
  NZ: { name: "New Zealand", currency: "New Zealand Dollar", currencyCode: "NZD", language: "English", dialCode: "+64", drivingSide: "Left", plugType: "Type I", tipping: "Not expected" },
  BR: { name: "Brazil", currency: "Brazilian Real", currencyCode: "BRL", language: "Portuguese", dialCode: "+55", drivingSide: "Right", plugType: "Type C / N", tipping: "10% often included on the bill" },
  MX: { name: "Mexico", currency: "Mexican Peso", currencyCode: "MXN", language: "Spanish", dialCode: "+52", drivingSide: "Right", plugType: "Type A / B", tipping: "10–15% at restaurants" },
  ZA: { name: "South Africa", currency: "South African Rand", currencyCode: "ZAR", language: "Zulu / Afrikaans / English", dialCode: "+27", drivingSide: "Left", plugType: "Type M / N", tipping: "10% at restaurants" },
  DEFAULT: { name: "Your area", currency: "Local currency", currencyCode: "—", language: "Local language", dialCode: "—", drivingSide: "Right", plugType: "Varies", tipping: "Check local custom before you go" },
};


export interface CountryMeta {
  name: string;
  currency: string;
  currencyCode: string;
  language: string;
  dialCode: string;
  drivingSide: "Right" | "Left";
  plugType: string;
  tipping: string;
}

// ─── Ride apps by country/region ─────────────────────────────────────────────
export const RIDE_APPS: Record<string, { name: string; url: string; color: string }[]> = {
  "US": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "Lyft", url: "https://lyft.com", color: "#FF00BF" },
  ],
  "GB": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "Bolt", url: "https://bolt.eu", color: "#34D186" },
    { name: "Free Now", url: "https://free-now.com", color: "#FFDD00" },
  ],
  "EE": [
    { name: "Bolt", url: "https://bolt.eu", color: "#34D186" },
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "Yandex Go", url: "https://taxi.yandex.com", color: "#FFCC00" },
  ],
  "LV": [
    { name: "Bolt", url: "https://bolt.eu", color: "#34D186" },
    { name: "Uber", url: "https://uber.com", color: "#000000" },
  ],
  "LT": [
    { name: "Bolt", url: "https://bolt.eu", color: "#34D186" },
    { name: "Uber", url: "https://uber.com", color: "#000000" },
  ],
  "DE": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "Free Now", url: "https://free-now.com", color: "#FFDD00" },
    { name: "Bolt", url: "https://bolt.eu", color: "#34D186" },
  ],
  "FR": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "Bolt", url: "https://bolt.eu", color: "#34D186" },
    { name: "Free Now", url: "https://free-now.com", color: "#FFDD00" },
  ],
  "ES": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "Cabify", url: "https://cabify.com", color: "#5C1DCC" },
    { name: "Bolt", url: "https://bolt.eu", color: "#34D186" },
  ],
  "IT": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "itTaxi", url: "https://www.ittaxi.it", color: "#E84118" },
    { name: "Free Now", url: "https://free-now.com", color: "#FFDD00" },
  ],
  "PT": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "Bolt", url: "https://bolt.eu", color: "#34D186" },
    { name: "Free Now", url: "https://free-now.com", color: "#FFDD00" },
  ],
  "NL": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "Bolt", url: "https://bolt.eu", color: "#34D186" },
  ],
  "SE": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "Bolt", url: "https://bolt.eu", color: "#34D186" },
  ],
  "NO": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "Bolt", url: "https://bolt.eu", color: "#34D186" },
  ],
  "DK": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "Bolt", url: "https://bolt.eu", color: "#34D186" },
  ],
  "FI": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "Bolt", url: "https://bolt.eu", color: "#34D186" },
    { name: "Yango", url: "https://yango.com", color: "#E43A00" },
  ],
  "TR": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "BiTaksi", url: "https://bitaksi.com", color: "#FF6B35" },
    { name: "Bolt", url: "https://bolt.eu", color: "#34D186" },
  ],
  "AE": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "Careem", url: "https://careem.com", color: "#3BB54A" },
  ],
  "IN": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "Ola", url: "https://olacabs.com", color: "#F8C300" },
    { name: "Rapido", url: "https://rapido.bike", color: "#EE3441" },
  ],
  "JP": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "GO", url: "https://go.mo-t.com", color: "#00A0E9" },
    { name: "DiDi", url: "https://didiglobal.com", color: "#FF6600" },
  ],
  "CN": [
    { name: "DiDi", url: "https://didiglobal.com", color: "#FF6600" },
    { name: "Shouqi", url: "https://shouqi.com.cn", color: "#0098D9" },
  ],
  "AU": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "DiDi", url: "https://didiglobal.com", color: "#FF6600" },
    { name: "Ola", url: "https://olacabs.com.au", color: "#F8C300" },
  ],
  "BR": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "99", url: "https://99app.com", color: "#F5A623" },
    { name: "inDrive", url: "https://indrive.com", color: "#44D62C" },
  ],
  "MX": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "DiDi", url: "https://didiglobal.com", color: "#FF6600" },
    { name: "inDrive", url: "https://indrive.com", color: "#44D62C" },
  ],
  "ZA": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "Bolt", url: "https://bolt.eu", color: "#34D186" },
    { name: "inDrive", url: "https://indrive.com", color: "#44D62C" },
  ],
  "KE": [
    { name: "Bolt", url: "https://bolt.eu", color: "#34D186" },
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "Little", url: "https://little.bz", color: "#E84118" },
  ],
  "NG": [
    { name: "Bolt", url: "https://bolt.eu", color: "#34D186" },
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "inDrive", url: "https://indrive.com", color: "#44D62C" },
  ],
  "TH": [
    { name: "Grab", url: "https://grab.com", color: "#00B14F" },
    { name: "Bolt", url: "https://bolt.eu", color: "#34D186" },
    { name: "inDrive", url: "https://indrive.com", color: "#44D62C" },
  ],
  "ID": [
    { name: "Gojek", url: "https://gojek.com", color: "#009900" },
    { name: "Grab", url: "https://grab.com", color: "#00B14F" },
  ],
  "MY": [
    { name: "Grab", url: "https://grab.com", color: "#00B14F" },
    { name: "AirAsia Ride", url: "https://ride.airasia.com", color: "#E21836" },
  ],
  "SG": [
    { name: "Grab", url: "https://grab.com", color: "#00B14F" },
    { name: "Gojek", url: "https://gojek.com", color: "#009900" },
    { name: "Tada", url: "https://tada.global", color: "#5E17EB" },
  ],
  "PH": [
    { name: "Grab", url: "https://grab.com", color: "#00B14F" },
    { name: "Angkas", url: "https://angkas.com", color: "#F7941D" },
  ],
  "VN": [
    { name: "Grab", url: "https://grab.com", color: "#00B14F" },
    { name: "Be", url: "https://be.com.vn", color: "#18BFFF" },
  ],
  "CA": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "Lyft", url: "https://lyft.com", color: "#FF00BF" },
  ],
  "NZ": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "Zoomy", url: "https://zoomy.co.nz", color: "#6400FF" },
  ],
  "DEFAULT": [
    { name: "Uber", url: "https://uber.com", color: "#000000" },
    { name: "Bolt", url: "https://bolt.eu", color: "#34D186" },
  ],
};




/* ── Geolocation → ISO country code + name + city.
   Same Geocoder call ShortChecking.tsx uses, centralized so it's
   never re-typed per screen. ── */
export interface GeoCountry {
  code: string;
  name: string;
  city: string | null;
}

export const getCountryCode = (lat: number, lng: number): Promise<GeoCountry> =>
  new Promise((resolve) => {
    if (!(window as any).google?.maps) {
      resolve({ code: "DEFAULT", name: COUNTRY_META.DEFAULT.name, city: null });
      return;
    }
    const geocoder = new (window as any).google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results: any[], status: string) => {
      if (status !== "OK" || !results?.length) {
        resolve({ code: "DEFAULT", name: COUNTRY_META.DEFAULT.name, city: null });
        return;
      }
      const comps = results[0].address_components ?? [];
      const countryComp = comps.find((c: any) => c.types.includes("country"));
      const code = countryComp?.short_name || "DEFAULT";
      const name = countryComp?.long_name || COUNTRY_META[code]?.name || COUNTRY_META.DEFAULT.name;
      const city =
        comps.find((c: any) => c.types.includes("locality"))?.long_name ??
        comps.find((c: any) => c.types.includes("administrative_area_level_2"))?.long_name ??
        null;
      resolve({ code, name, city });
    });
  });

/** Flag emoji from a 2-letter ISO country code. */
export const flagEmoji = (code: string): string => {
  if (!code || code.length !== 2) return "🌍";
  return String.fromCodePoint(...[...code.toUpperCase()].map((c) => 127397 + c.charCodeAt(0)));
};